// libraries
import Vue from 'vue'
const _ = require('lodash')

const resource = 'conversation'
const resourceName = 'conversación'
const resourceNamePlural = 'conversaciones'

const state = {
  messages: [],
  search_messages: [],
  filters: {
    platforms: [],
    labels: [],
    admins: [],
    box: 'general',
    unread: false,
    search_text: '',
    // tags for cases
    tags: [],
    case_statuses: [],
    dates: {
      // createdAt: null,
      // createdAtEnd: null,
      updatedAt: null,
      updatedAtEnd: null
      // last_message_tim: null,
      // last_message_time_end: null
    }
  },
  pivot: null
}

state[resource + 's'] = []

// functions receive state
const getters = {
  selectedPlatformsNames (state) {
    return Array.isArray(state.filters.platforms) ? state.filters.platforms.map(p => p.name).join(',') : ''
  },
  selectedLabelsIds (state) {
    return Array.isArray(state.filters.labels) ? state.filters.labels.map(f => f.label_id).join(',') : ''
  },
  selectedTagsIds (state) {
    return Array.isArray(state.filters.tags) ? state.filters.tags.map(f => f.tag_id).join(',') : ''
  },
  selectedAdminsIds (state) {
    return Array.isArray(state.filters.admins) ? state.filters.admins.map(f => f.admin_id).join(',') : ''
  },
  selectedMessage (state) {
    return state.pivot
  },
  searchText (state) {
    return state.filters.search_text
  },
  selectedStatuses() {
    return state.filters.case_statuses
  }
}

// functions receive context and params
const actions = {
  async all ({ commit }, params) {
    try {
      if (params.params.page == 1) { commit('setItems', []) }
      const res = await Vue.request.get(`account/${params.account_id}/${resource}s`, { params: params.params || {} })
      if (res.data.success) {
        commit('concatItems', res.data.resource)
        if (params.callback) { params.callback(res.data) }
      } else {
        if (params.callback) { params.callback({ error: `Error obteniendo ${resourceNamePlural}.` }) }
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceNamePlural}.` }) }
      console.error(e)
    }
  },
  async getByMessages ({ commit }, params) {
    try {
      if (params.params.page == 1) { commit('setItems', []) }
      const res = await Vue.request.get(`account/${params.account_id}/conversations_by_messages`, { params: params.params || {} })
      if (res.data.success) {
        commit('concatItems', res.data.resource)
        if (params.callback) { params.callback(res.data) }
      } else {
        if (params.callback) { params.callback({ error: `Error obteniendo ${resourceNamePlural}.` }) }
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceNamePlural}.` }) }
      console.error(e)
    }
  },
  async getMessageDetails ({ commit }, params) {
    try {
      const res = await Vue.request.get(`message/${params.message_id}`, { params: params.params || {} })
      if (res.data.success) {
        commit('concatItems', res.data.resource)
        if (params.callback) { params.callback(res.data.resource) }
      } else {
        if (params.callback) { params.callback({ error: 'Error obteniendo detalles del mensaje.' }) }
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error obteniendo detalles del mensaje.' }) }
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      const res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo ${resourceName}...` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceName}.` }) }
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      const res = await Vue.request.post(`${resource}`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error creando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error creando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      const res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, { data: params })
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error eliminando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error eliminando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async messages ({ commit }, params) {
    try {
      if (params.params.page == 1 && params.params.sort == -1) { commit('setMessages', []) }
      const res = await Vue.request.get(`${resource}/${params[resource + '_id']}/messages`, { params: params.params || {} })

      if (res.data.success && params.callback) {
        if (params.params.sort == -1) {
          commit('concatMessages', res.data.resource)
        } else {
          commit('pushMessages', res.data.resource)
        }
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: 'Error obteniendo mensajes.' })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error obteniendo mensajes.' }) }
      console.error(e)
    }
  },
  async searchMessages ({ commit }, params) {
    try {
      if (params.params.page == 1) { commit('setSearchMessages', []) }
      const res = await Vue.request.get(`${resource}/${params[resource + '_id']}/search_messages`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        commit('concatSearchMessages', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: 'Error obteniendo busqueda de mensajes.' })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error obteniendo busqueda de mensajes.' }) }
      console.error(e)
    }
  },
  async getPivotMessages ({ commit }, params) {
    try {
      if (params.params.page == 1) { commit('setMessages', []) }
      const res = await Vue.request.get(`message/${params.message_id}/pivot_messages`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        commit('concatMessages', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: 'Error obteniendo mensajes.' })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error obteniendo mensajes.' }) }
      console.error(e)
    }
  }
}

// functions receive state
const mutations = {
  resetConversations(state) {
    state[resource + 's'] = []
  },
  setMessagesSearch(state, items) {
    state[resource + 's'] = [...state[resource + 's'], ...items]
  },
  setItems (state, items) {
    let conversations = _.uniqBy(items, '_id')
    conversations = _.orderBy(conversations, ['read'], ['asc'])
    state[resource + 's'] = conversations
  },
  concatItems (state, items) {
    let conversations = _.uniqBy(items, '_id')
    conversations = state[resource + 's'].concat(conversations)
    conversations = _.orderBy(conversations, ['read'], ['asc'])
    state[resource + 's'] = conversations
  },
  pushConversation (state, conversation) {
    const index = state[resource + 's'].findIndex(c => c._id === conversation._id)

    if (index < 0) {
      state[resource + 's'].push(conversation)
    }
  },
  unshiftConversation (state, conversation) {
    const index = state[resource + 's'].findIndex(c => c._id === conversation._id)
    if (index < 0) {
      state[resource + 's'].unshift(conversation)
    }
  },
  removeConversation (state, conversationId) {
    const index = state[resource + 's'].findIndex(c => c._id === conversationId)

    if (index >= 0) state[resource + 's'].splice(index, 1)
  },
  setMessages (state, items) {
    state.messages = items.reverse()
  },
  concatMessages (state, items) {
    items.forEach(m => {
      state.messages.unshift(m)
    })
  },
  pushMessages (state, items) {
    items.forEach(m => {
      state.messages.push(m)
    })
  },
  pushMessage (state, message) {
    if (!state.pivot) {
      state.messages.push(message)
    }
  },
  filtersPlatforms (state, platforms) {
    state.filters.platforms = platforms
  },
  removefilterPlatform (state, name) {
    const index = state.filters.platforms.findIndex(p => p.name == name)
    if (index >= 0) {
      state.filters.platforms.splice(index, 1)
    }
  },
  filtersLabels (state, labels) {
    state.filters.labels = labels
  },
  filtersTags (state, tags) {
    state.filters.tags = tags
  },
  filtersAdmins (state, admins) {
    state.filters.admins = admins
  },
  removefilterAdmin (state, admin_id) {
    const index = state.filters.admins.findIndex(a => a.admin_id == admin_id)
    if (index >= 0) {
      state.filters.admins.splice(index, 1)
    }
  },
  filtersBox (state, box) {
    state.filters.box = box
  },
  filtersUnread (state, unread) {
    state.filters.unread = unread
  },
  filtersCaseStatuses (state, status) {
    const index = state.filters.case_statuses.findIndex(s => s == status.value)

    if (status.event == false) {
      if (index >= 0) state.filters.case_statuses.splice(index, 1)
    } else {
      if (index == -1) state.filters.case_statuses.push(status.value)
    }
  },
  filtersDates (state, dates) {
    state.filters.dates.updatedAt = dates ? Vue.prototype.$moment(dates.startDate).format('YYYY-MM-DD') : null
    state.filters.dates.updatedAtEnd = dates ? Vue.prototype.$moment(dates.endDate).format('YYYY-MM-DD') : null
    // state.filters.dates.last_message_time = dates ? Vue.prototype.$moment(dates.endDate).format('HH:mm') : null
    // state.filters.dates.last_message_time_end = dates ? Vue.prototype.$moment(dates.endDate).format('HH:mm') : null
  },
  updateConversation (state, conversation) {
    const index = state[resource + 's'].findIndex(c => c._id === conversation._id)
    if (index >= 0) {
      const deleted = state[resource + 's'].splice(index, 1)[0]
      conversation.user = deleted.user
      conversation.platform_model = deleted.platform_model
      state[resource + 's'].splice(index, 0, conversation)
    } else {
      state[resource + 's'].splice(index, 0, conversation)
    }
  },
  updateConversationData (state, data) {
    const conversation = state[resource + 's'].find(c => c._id === data._id)

    if (conversation) {
      if (data.sub_key) {
        conversation[data.key][data.sub_key] = data.value
      } else {
        conversation[data.key] = data.value
      }
    }
  },
  moveConversationToTop (state, message) {
    const index = state[resource + 's'].findIndex(({ _id }) => _id === message.conversation_id)

    if (index > -1) {
      state[resource + 's'][index].last_message_preview = message.message.text
      state[resource + 's'][index].read = message.conversation.read

      if (index > 0) state[resource + 's'].splice(0, 0, state[resource + 's'].splice(index, 1)[0])
    } else {
      actions.get({}, {
        conversation_id: message.conversation_id,
        callback: res => {
          if (res.error) return console.log(res.error)

          res.resource.last_message_preview = message.message.text
          state[resource + 's'].splice(0, 0, res.resource)
        }
      })
    }
  },
  updateConversationsLastMessage (state, message) {
    const conversation = state[resource + 's'].find(c => c._id == message.conversation_id)
    if (conversation) {
      conversation.last_message_preview = message.message.text
    }
  },
  resetAllFilters (state) {
    state.filters = {
      platforms: [],
      labels: [],
      admins: [],
      box: 'general',
      unread: false,
      // tags for cases
      tags: [],
      case_statuses: [],
      dates: {
        // createdAt: null,
        // createdAtEnd: null,
        updatedAt: null,
        updatedAtEnd: null
        // last_message_tim: null,
        // last_message_time_end: null
      }
    }
  },
  setSearchMessages (state, items) {
    state.search_messages = items.reverse()
  },
  concatSearchMessages (state, items) {
    items.forEach(m => {
      if (m.event_type === 'message_content') {
        state.search_messages.unshift(m)
      }
    })
  },
  selectMessage (state, item) {
    state.pivot = item
  },
  resetSelectedMessage(state) {
    state.pivot = null
  },
  filtersSearch (state, text) {
    state.filters.search_text = text
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
